var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-enum',{attrs:{"config":_vm.config,"size":_vm.size},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }